'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var CID = require('cids');

var errCode = require('err-code');

var _require = require('../../utils'),
    withTimeoutOption = _require.withTimeoutOption;

function normalizeMultihash(multihash, enc) {
  if (typeof multihash === 'string') {
    if (enc === 'base58' || !enc) {
      return multihash;
    }

    return Buffer.from(multihash, enc);
  } else if (Buffer.isBuffer(multihash)) {
    return multihash;
  } else if (CID.isCID(multihash)) {
    return multihash.buffer;
  }

  throw new Error('unsupported multihash');
}

module.exports = function (_ref) {
  var ipld = _ref.ipld,
      preload = _ref.preload;
  return withTimeoutOption( /*#__PURE__*/function () {
    var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(multihash, options) {
      var mh, cid;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // eslint-disable-line require-await
              options = options || {};
              _context.prev = 1;
              mh = normalizeMultihash(multihash, options.enc);
              _context.next = 8;
              break;

            case 5:
              _context.prev = 5;
              _context.t0 = _context["catch"](1);
              throw errCode(_context.t0, 'ERR_INVALID_MULTIHASH');

            case 8:
              _context.prev = 8;
              cid = new CID(mh);
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t1 = _context["catch"](8);
              throw errCode(_context.t1, 'ERR_INVALID_CID');

            case 15:
              if (options.cidVersion === 1) {
                cid = cid.toV1();
              }

              if (options.preload !== false) {
                preload(cid);
              }

              return _context.abrupt("return", ipld.get(cid, {
                signal: options.signal
              }));

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 5], [8, 12]]);
    }));

    function get(_x, _x2) {
      return _get.apply(this, arguments);
    }

    return get;
  }());
};